import template from './rangeInput.html';
import controller from './rangeInput.controller';
import './rangeInput.styl';

let RangeInputComponent = () => {
  return {
    template,
    controller,
    controllerAs: 'vm',
    restrict: 'E',
    scope: {},
    bindToController: {
      item: '='
    },
    link: (scope, element, attrs) => {
      scope.$watch('vm.item.value', (newValue, oldValue) => {
        if (newValue) {
          scope.vm.updateLabel(newValue);
        }
      }, true);
    }
  };
};

export default RangeInputComponent;


// WEBPACK FOOTER //
// ./src/components/rangeInput/rangeInput.component.js